// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1bjyo","modalForm":"UpgradeEpcsModal_modalForm__jizup","modalFooter":"UpgradeEpcsModal_modalFooter__1-FKU"};